<template>
	<div
		class="overflow-xh-ya mt-3 pl-2"
		style="max-height: calc(100vh - 200px); overflow: hidden"
	>
		<b-row
			:class="{
				'mt-3': !editNotes,
			}"
		>
			<b-col class="mr-3">
				<TextField
					text="Title"
					placeholder="Enter"
					modelKey="$model"
					:modelValue="validation.title"
					:error="validation.title.$error"
				/>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="12" class="assetbank-tags">
				<FormTags
					placeholder="e.g.,personal"
					:isMandatory="false"
					class="mr-3"
					modelKey="tags"
					:modelValue="notesData"
				/>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col class="mr-3">
				<QuillEditor
					label="Description"
					modelKey="$model"
					:modelValue="validation.notes"
					:error="validation.notes.$error"
				/>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	props: {
		notesData: Object,
		editNotes: Boolean,
		validation: Object,
	},
};
</script>

<style>
.assetbank-tabs .assetbank-tags ul {
	width: 100%;
}
.assetbank-tabs .assetbank-tags ul li {
	width: fit-content;
}
</style>
